<template>
  <div>
    <b-card>
      <div class="d-flex">
        <h4 class="mb-0">Gallery Information</h4>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="ml-auto"
          @click="showGalleryModal = true"
        >
          Gallery Images
        </b-button>
      </div>

      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-1" @submit.prevent="onSubmit">
          <b-row>
            <b-col cols="12" v-if="gallaryData.gallary_image_path" class="d-flex justify-content-center">

              <img
               style="width: 100%; max-width: 300px"
                :src="getImgPath(gallaryData.gallary_image_path)"
              />
            </b-col>
            <b-col cols="12">
              <hr />
            </b-col>
            <b-col md="12">
              <b-form-group label="Banner Image" label-cols-md="3">
                <el-upload
                  class="avatar-uploader"
                  list-type="picture-card"
                  ref="upload"
                  :action="uploadUrl"
                  :headers="headerObj"
                  name="image_file"
                  :file-list="fileList"
                  multiple
                  :limit="1"
                  :data="gallaryData"
                  :on-change="onChange"
                  :on-remove="handleRemove"
                  :before-remove="beforeRemove"
                  :auto-upload="false"
                  :class="{ hideUpload: !showUpload }"
                >
                  <img
                    v-if="gallaryData.gallary_image_path && false"
                    :src="getImgPath(gallaryData.gallary_image_path)"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12">
                <b-form-group label="Title" label-for="gallary_main_title" label-cols-md="3">
                 <b-form-input
                      id="title"
                      v-model="gallaryData.title"
                    />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group label="Content" label-for="gallary_content" label-cols-md="3">

                  <!-- 添加模式切换开关 -->
                  <!-- <b-form-checkbox
                    v-model="isHtmlMode"
                    switch
                    class="mb-2"
                  >
                    {{ isHtmlMode ? 'HTML Mode' : 'Rich Text Mode' }}
                  </b-form-checkbox> -->

                  <!-- HTML 编辑模式 -->


                 <TinyMCEEditor :content.sync="gallaryData.content" />
                  <!-- <b-form-textarea
                    v-if="isHtmlMode"
                    v-model="gallaryData.content"
                    rows="10"
                    placeholder="Enter HTML content"
                  /> -->
                  <!-- <quill-editor
                      v-else
                    class="gallary-content"
                    v-model="gallaryData.content"
                  /> -->
<!--
                  <monaco-editor
                    v-if="isHtmlMode"
                    v-model="gallaryData.content"
                    language="html"
                    theme="vs-dark"
                    style="min-height: 400px"
                    :options="{
                      formatOnPaste: true,
                      formatOnType: true,
                      autoIndent: true,
                      minimap: { enabled: false },
                      lineNumbers: 'on'
                    }"
                  /> -->



                  <!-- 富文本���辑模式 -->
                  <!-- <quill-editor
                    v-else
                    class="gallary-content"
                    v-model="gallaryData.content"
                  /> -->
                </b-form-group>
              </b-col>
          </b-row>
          <!-- Form Actions -->

            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
              >
                Save
              </b-button>

            </div>
        </b-form>
      </b-overlay>
    </b-card>

    <b-modal
      v-model="showGalleryModal"
      title="Gallery Images"
      size="lg"
      hide-footer
      centered
    >
      <b-overlay
        :show="galleryLoading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <div class="gallery-grid">
          <div
            v-for="image in galleryImages"
            :key="image.id"
            class="gallery-item"
          >
            <img :src="image.image_url" />
            <div class="gallery-item-actions">
              <b-button
                variant="danger"
                size="sm"
                @click="deleteImage(image.id)"
              >
                Delete
              </b-button>
            </div>
          </div>

          <div class="gallery-upload">
            <el-upload
              ref="uploadRef"
              class="uploader"
              :action="uploadUrl + '/images'"
              :headers="headerObj"
              name="file"
              :show-file-list="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :auto-upload="true"
              :data="{ store_id: storeId }"
            >
              <div class="upload-trigger">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  size="sm"
                >
                  Upload Image
                </b-button>
              </div>
            </el-upload>
          </div>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BCard,
  BCardBody,
  BButton,
  BFormCheckbox,
  BFormDatepicker,
  BInputGroupAppend,
  BInputGroup,
  BFormInvalidFeedback,
  BOverlay,
  BFormTextarea,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import store_galleryStoreModule from "./storeGalleryStoreModule";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import TinyMCEEditor from "@/layouts/components/TinyMCEEditor.vue"
import {getUserData} from '@/auth/utils'

import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {

  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BFormCheckbox,
    BFormDatepicker,
    BInputGroupAppend,
    BInputGroup,
    BFormInvalidFeedback,
    BOverlay,
    BFormTextarea,
    quillEditor,
    TinyMCEEditor
  },
  methods: {
    toggleUpload() {
        this.showUpload = !this.showUpload
      },
    getImgPath(path) {
      return process.env.VUE_APP_IMAGE_URL + path;
    },
    onSubmit() {
      this.$swal({
        title: "Are you sure you want to save?",
        showCancelButton: true,

        confirmButtonText: "Save",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let formData = new FormData()
          formData.append('store_id', getUserData().store_id)
          if(this.gallaryData.file) {
            formData.append('file', this.gallaryData.file)
          }

          formData.append('id', this.gallaryData.id || 0)

          if(this.gallaryData.title){
            formData.append('title', this.gallaryData.title)
          }else{
            formData.append('title', "")
          }
          if(this.gallaryData.content){
            formData.append('content', this.gallaryData.content)
          }else{
            formData.append('content', "")
          }

          this.loading = true
          store
            .dispatch("store_gallery/updateStoreGallery", formData)
            .then((response) => {
              this.loading = false
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              })
              this.refetchData()
            })
            .catch((error) => {
              this.loading = false
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              })
            })
        }
      })
    },
    handleRemove() {
      this.showUpload = true
      this.gallaryData.file = null
      this.gallaryData.gallary_image_path = null
    },

    beforeRemove() {
  /*     return new Promise((resolve) => {
        this.$swal({
          title: 'Are you sure you want to delete this image?',
          text: 'You will need to submit a new picture.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then((result) => {
          resolve(result.value)
        })
      }) */
    },
  },
  setup() {
    const loading = ref(false)
    const isHtmlMode = ref(true)
    const fileList = ref([])
    const gallaryData = ref({
      id: 0,
      title: '',
      content: '',
      file: null,
      gallary_image_path: null
    })
    const showUpload = ref(true)

    const showGalleryModal = ref(false)
    const galleryLoading = ref(false)
    const galleryImages = ref([])

    // 獲取當前用戶的 store_id
    const storeId = getUserData().store_id

    // 注册 store module
    if (!store.hasModule('store_gallery')) {
      store.registerModule('store_gallery', store_galleryStoreModule)
    }

    // 组件卸载时注销 module
    onUnmounted(() => {
      if (store.hasModule('store_gallery')) {
        store.unregisterModule('store_gallery')
      }
    })

    // 获取初始数据
    const refetchData = () => {
      loading.value = true
      store.dispatch('store_gallery/fetchStoreGallery' , {store_id: getUserData().store_id})
        .then((response) => {
          const store_gallery = response.data.store_gallery
          if (store_gallery) {
            gallaryData.value = {
              id: store_gallery.id,
              title: store_gallery.title,
              content: store_gallery.content,
              gallary_image_path: store_gallery.image_path
            }
          }
        })
        .catch(error => {
          console.error('获取数据失败:', error)
        })
        .finally(() => {
          loading.value = false
        })
    }

    onMounted(() => {
      refetchData()
    })

    // 文件改变处理
    const onChange = (file) => {
      if (file) {
        showUpload.value = !showUpload.value
        gallaryData.value.file = file.raw
      }
    }

    const fetchGalleryImages = () => {
      galleryLoading.value = true
      store.dispatch('store_gallery/fetchGalleryImages', {store_id: getUserData().store_id})
        .then(response => {
          galleryImages.value = response.data.images
        })
        .catch(error => {
          console.error('获取画廊图片失败:', error)
        })
        .finally(() => {
          galleryLoading.value = false
        })
    }

    const handleUploadSuccess = (response) => {
      fetchGalleryImages()
    }

    const handleUploadError = (error) => {
      console.error('上传失败:', error)
    }

    const deleteImage = (id) => {
      store.dispatch('store_gallery/deleteGalleryImage', { imageId: id, store_id: getUserData().store_id })
        .then(() => {
          fetchGalleryImages()
        })
        .catch(error => {
          console.error('删除失败:', error)
        })
    }

    onMounted(() => {
      fetchGalleryImages()
    })

    const uploadRef = ref(null)

    const triggerUpload = () => {
      // 触发上传组件的点击事件
      uploadRef.value.$el.querySelector('input[type="file"]').click()
    }

    const beforeUpload = (file) => {
      // 阻止事件冒泡
      event?.stopPropagation()
      return true
    }

    return {
      loading,
      isHtmlMode,
      fileList,
      gallaryData,
      onChange,
      refetchData,
      showUpload,
      uploadUrl: process.env.VUE_APP_SERVICE_URL + '/store_gallery',
      headerObj: {
        Authorization: 'Bearer ' + localStorage.getItem('accessToken')
      },
      showGalleryModal,
      galleryLoading,
      galleryImages,
      handleUploadSuccess,
      handleUploadError,
      deleteImage,
      uploadRef,
      triggerUpload,
      beforeUpload,
      storeId, // 添加 storeId 到返回值中
    }
  },
};
</script>

<style lang="scss">

</style>